/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from "react";

import { Tab } from "@headlessui/react";
import moment from "moment";

import ButtonNew from "components/atoms/ButtonNew/index";
import { HiChevronLeft } from "components/atoms/Icon/hi/HiChevronLeft";
import { HiChevronRight } from "components/atoms/Icon/hi/HiChevronRight";

import Accordion from "../Accordion";
import Calendar from "../Calendar";
import TimeLineReport from "../TimeLineReport/index";

import style from "./Index.module.scss";

const colors = [
  "#00C071",
  "#8843F2",
  "#FF8E00",
  "#D90000",
  "#1C1427",
  "#0C1E7F",
  "#0CECDD",
  "#B5FFD9",
  "#FFD371",
  "#ECB365",
  "#005F99",
  "#EF2F88",
  "#2FA4FF",
  "#4D4C7D",
  "#FF1700",
  "#0E185F",
  "#3B0000",
  "#041C32",
  "#064663",
];

function getDateOfQuarter(date) {
  const quarter = Math.floor((date.getMonth() + 3) / 3);

  switch (quarter) {
    case 1:
      return new Date(`${date.getFullYear().toString()}/03/31`);
    case 2:
      return new Date(`${date.getFullYear().toString()}/06/30`);
    case 3:
      return new Date(`${date.getFullYear().toString()}/09/30`);
    case 4:
      return new Date(`${date.getFullYear().toString()}/12/31`);
    default:
      break;
  }
}

export function ResultScreen({ data, btnBack, itemData, ...props }) {
  const [timeStamp, setTimeStamp] = useState(null);
  const [timeStampFYE, setTimeStampFYE] = useState(null);
  const [complianceTimes, setComplianceTimes] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState();
  const ComplianceInput = data.filter(
    (item) =>
      item.deadline_months ||
      item.deadline_dates ||
      item.deadline_date_result ||
      item.deadline_static_date ||
      item.quarter ||
      item.deadline_between
  );
  const IncorpCompliance = ComplianceInput.filter(
    (item) => !item.fye && !item.deadline_static_date
  );

  const FYECompliance = ComplianceInput.filter((item) => item.fye === true);
  const OthersCompliance = data.filter(
    (item) =>
      !(
        item.deadline_months ||
        item.deadline_dates ||
        item.deadline_date_result ||
        item.deadline_static_date ||
        item.quarter ||
        item.deadline_between
      )
  );
  /* Calculate Data */
  const getResult = (dataCompliance, timeDynamic) => {
    // eslint-disable-next-line array-callback-return
    const dataCalculator = dataCompliance?.map((item) => {
      if (item.deadline_static_date) {
        const date = new Date();
        const time = Date.parse(
          `${
            item.next_year
              ? (date.getFullYear() + 1).toString()
              : date.getFullYear().toString()
          }/${item.deadline_static_date}`
        );

        return new Date(time);
      }
      if (timeDynamic) {
        const time = new Date(timeDynamic.toString());

        if (item.deadline_between) {
          // eslint-disable-next-line init-declarations
          let timeResult;

          if (item.deadline_months_before || item.deadline_months_after) {
            const tempDate = new Date(
              time.setMonth(
                timeDynamic.getMonth() <= item.deadline_between &&
                  item.deadline_between_year &&
                  timeDynamic.getFullYear() < item.deadline_between_year
                  ? timeDynamic.getMonth() + item.deadline_months_before
                  : timeDynamic.getMonth() + item.deadline_months_after
              )
            );

            timeResult = new Date(
              tempDate.setDate(
                tempDate.getDay() + item.deadline_plus_date
                  ? item.deadline_plus_date
                  : 0
              )
            );
          } else {
            const date = new Date();

            timeResult = Date.parse(
              `${date.getFullYear().toString()}/${
                timeDynamic.getMonth() <= item.deadline_between
                  ? item.deadline_static_date_before
                  : item.deadline_static_date_after
              }`
            );
          }

          return new Date(timeResult);
        }
        if (item.deadline_months) {
          const newDate = new Date(
            time.setMonth(time.getMonth() + item.deadline_months)
          );

          if (item.deadline_date_result) {
            const dateResult = new Date(
              newDate.setDate(item.deadline_date_result)
            );

            return dateResult;
          }
          if (item.deadline_plus_date) {
            const timeResult = new Date(
              newDate.setDate(newDate.getDay() + item.deadline_plus_date)
            );

            return timeResult;
          }

          return newDate;
        }
        if (item.deadline_dates) {
          const newDate = new Date(
            time.setDate(time.getDate() + item.deadline_dates)
          );

          return newDate;
        }
        if (item.quarter) {
          return getDateOfQuarter(time);
        }
      } else {
        return null;
      }
    });

    const getTime = dataCalculator.map((item, index) => ({
      id: index,
      title: dataCompliance[index].title,
      isFYE: dataCompliance[index].fye,
      start: new Date(item),
      end: new Date(item),
      description: dataCompliance[index].content,
      color:
        colors[
          ComplianceInput.findIndex(
            (item) => item.title === dataCompliance[index].title
          )
        ],
    }));

    setComplianceTimes([
      ...getTime,
      ...complianceTimes.filter(
        (item) =>
          !getTime.map((itemTime) => itemTime.title).includes(item.title)
      ),
    ]);
  };
  /* Render Element */
  const renderCalendar = useCallback(() => {
    if (selectedMonth) {
      return (
        <Calendar
          data={complianceTimes}
          selectedMonth={selectedMonth}
          setSelectedMonth={setSelectedMonth}
        />
      );
    }

    return <YearView data={complianceTimes} selectMonth={setSelectedMonth} />;
  }, [
    IncorpCompliance,
    FYECompliance,
    timeStamp,
    timeStampFYE,
    complianceTimes,
    selectedMonth,
  ]);

  /* Handle Effect */
  useEffect(() => {
    if (timeStamp) {
      getResult(IncorpCompliance, timeStamp);
    } else {
      setComplianceTimes((prev) => prev.filter((item) => item.isFYE));
    }
  }, [timeStamp]);
  useEffect(() => {
    if (timeStampFYE) {
      getResult(FYECompliance, timeStampFYE);
    } else {
      setComplianceTimes((prev) => prev.filter((item) => !item.isFYE));
    }
  }, [timeStampFYE]);

  useEffect(() => {
    props.setStep(2);
    getResult(ComplianceInput.filter((item) => item.deadline_static_date));
  }, []);

  return (
    <div className={style.resultScreen}>
      <h4 className="mb-6 mt-6 text-center font-medium lg:mt-10">
        {itemData?.result_title
          ? itemData?.result_title
          : "You’ve completed the Compliance Self-Assessment test, here are the results:"}
      </h4>
      <p className="mb-6 text-left">
        Our compliance tool provides a compact calendar of future deadlines and
        events. To reveal specific due dates for timeline-based compliance
        duties, key in the required information in the timeline reporting row.
      </p>
      <div className="mb-6 lg:mb-10">
        {ComplianceInput.map((item, index) => (
          <div key={index} className=" inline-flex items-center p-4">
            <span
              className={"mr-2 inline-block h-5 w-5 rounded-full"}
              style={{ background: colors[index] }}
            ></span>
            <span className="font-medium"> {item.title}</span>
          </div>
        ))}
      </div>
      {(IncorpCompliance.length > 0 || FYECompliance.length > 0) && (
        <div className=" mb-6 rounded-lg bg-bbc-main p-6 lg:mb-10">
          <h4 className="mb-4 text-lg font-medium">Timeline Reporting:</h4>
          <div className="items-[flex-start] row justify-between">
            {IncorpCompliance.length > 0 && (
              <div className="md:col-6 xl:col-5">
                <TimeLineReport
                  timeStamp={timeStamp}
                  setTimeStamp={setTimeStamp}
                  title={"Incorporation Date"}
                  type={"Incorp"}
                  description="Please enter your incorporation date. The reporting timeline will be displayed below"
                />
              </div>
            )}

            {FYECompliance.length > 0 && (
              <div className="mt-6 md:col-6 md:mt-0 xl:col-4 ">
                <TimeLineReport
                  timeStamp={timeStampFYE}
                  setTimeStamp={setTimeStampFYE}
                  title={"FYE"}
                  type={"FYE"}
                  description="Please enter your incorporation date or FYE date. The reporting timeline will be displayed below"
                />
              </div>
            )}
          </div>
        </div>
      )}
      {(complianceTimes.length > 0 ||
        IncorpCompliance.length > 0 ||
        FYECompliance.length > 0) && <>{renderCalendar()}</>}

      {OthersCompliance.length > 0 && (
        <>
          <p className="mb-6 text-lg font-semibold text-bbc-accent-2">
            {complianceTimes.length > 0
              ? "Other compliances:"
              : "Your compliances:"}
          </p>
          <Accordion data={OthersCompliance} />
        </>
      )}

      <div className="mt-10  text-bbc-neutral-700">
        <span className="mb-4 block font-medium">Disclaimer</span>
        This information is provided as a convenience to firms, but it&apos;s
        important that you do your own research and check for any additional
        requirements. This report does not constitute an exhaustive list of all
        the firm’s regulatory obligations-they must still ensure compliance with
        their own country&apos;s laws in ordering themselfes from liability
        risks.
      </div>
      <div className="w-100 mt-4 text-center">
        <div>
          <ButtonNew
            onClick={async () => {
              // eslint-disable-next-line no-undef
              await Tawk_API.toggle();
            }}
            othersClass="font-bold uppercase"
            btnPadding={"px-4  sm:px-6 py-2"}
          >
            TALK TO OUR EXPERT
          </ButtonNew>
          <p className="mt-2 ">
            <span>or </span>
            <a
              href={itemData?.link}
              rel="noreferrer"
              target="_blank"
              className="font-bold text-bbc-brand-500"
            >
              Find out the right plan for you
            </a>
          </p>
          {btnBack}
        </div>
      </div>
    </div>
  );
}
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
const YearView = ({ data, selectMonth }) => {
  const getYears = [
    ...new Set(
      data.map((item) => item.start.getFullYear()).sort((a, b) => a - b)
    ),
  ];
  const [yearIndex, setYearIndex] = useState(0);
  const handleNext = () => {
    setYearIndex((prev) => prev + 1);
  };
  const handlePrev = () => {
    setYearIndex((prev) => prev - 1);
  };
  const checkEventPositionMonth = (month) => {
    const dataFilterByMonth = data.filter(
      (item) =>
        item.start.getMonth() + 1 === month &&
        item.start.getFullYear() === getYears[yearIndex]
    );

    return dataFilterByMonth.map((item, index) => (
      <span
        key={index}
        className={"mr-2 inline-block h-5 w-5 rounded-full"}
        style={{
          background: item.color,
        }}
      ></span>
    ));
  };

  return (
    <div className={"relative mb-10"}>
      <div className={" m-auto max-w-xs  pb-7 "}>
        <div className="flex justify-center text-center">
          <button
            onClick={() => {
              handlePrev();
            }}
            disabled={yearIndex === 0}
            className={`mr-24  disabled:grayscale ${
              getYears.length > 1 ? "block" : "hidden"
            }`}
          >
            <HiChevronLeft
              size={24}
              color="#007eff"
              className="rounded-md bg-bbc-brand-100 p-0.5"
            />
          </button>
          <p className="text-2xl font-semibold leading-9">
            {getYears[yearIndex] || new Date().getFullYear()}
          </p>
          <button
            onClick={() => {
              handleNext();
            }}
            disabled={yearIndex === getYears.length - 1}
            className={`ml-24 disabled:grayscale ${
              getYears.length > 1 ? "block" : "hidden"
            }`}
          >
            <HiChevronRight
              size={24}
              color="#007eff"
              className="rounded-md bg-bbc-brand-100 p-0.5 "
            />
          </button>
        </div>
      </div>
      <div className="z-1 relative mb-10">
        <div className="mb-7 flex flex-col">
          <Tab.Group defaultIndex={0}>
            <Tab.List className="relative mb-10 flex justify-center  lg:justify-start">
              {["Calendar", "List"].map((item, index) => (
                <Tab
                  key={index}
                  className={({ selected }) =>
                    classNames(
                      "min-w-[80px] cursor-pointer   rounded-full border px-4 py-1 text-center text-sm font-medium leading-6",
                      selected
                        ? "border-bbc-brand-500 text-bbc-brand-500"
                        : "border-transparent text-bbc-neutral-800"
                    )
                  }
                  as="div"
                >
                  {item}
                </Tab>
              ))}
            </Tab.List>
            <Tab.Panels>
              <Tab.Panel
                key={0}
                as="div"
                className="focus:right-0 focus:outline-none"
              >
                <div className="grid auto-cols-fr grid-flow-col grid-rows-3 gap-0 border-r border-b">
                  {[1, 5, 9, 2, 6, 10, 3, 7, 11, 4, 8, 12].map(
                    (item, index) => (
                      <div
                        key={index}
                        className="cursor-pointer border-t border-l p-6 text-right text-lg font-medium hover:bg-bbc-brand-100"
                        onClick={() => {
                          selectMonth({
                            month: item,
                            year: getYears[yearIndex],
                          });
                        }}
                      >
                        <span className="block" style={{ minHeight: "100px" }}>
                          {item}
                        </span>
                        <div className="text-left">
                          {checkEventPositionMonth(item)}
                        </div>
                      </div>
                    )
                  )}
                </div>
              </Tab.Panel>
              <Tab.Panel
                key={1}
                as="div"
                className="focus:right-0 focus:outline-none"
              >
                {data
                  .filter(
                    (item) => item.start.getFullYear() === getYears[yearIndex]
                  )
                  .map((item, index) => (
                    <div
                      className="mb-4 rounded-lg border bg-white px-6 py-4 last:mb-0"
                      key={index}
                    >
                      <div className="mb-2 font-medium">
                        {moment(item.start).format("LL")}
                      </div>
                      <div
                        className="mb-4 inline-block rounded-md py-2 px-6 font-medium text-white"
                        style={{ backgroundColor: item.color }}
                      >
                        {item.title}
                      </div>
                      <div
                        className="paragraph"
                        dangerouslySetInnerHTML={{ __html: item.description }}
                      ></div>
                    </div>
                  ))}
              </Tab.Panel>
            </Tab.Panels>
          </Tab.Group>
        </div>
      </div>
      <div
        className={`absolute inset-0 h-full w-full grayscale ${
          getYears.length === 0 ? " block" : "hidden"
        }`}
      ></div>
    </div>
  );
};
